import React, {Component} from 'react';
import { withRouter } from "react-router-dom";




class ComingSoon extends Component {
    constructor(props) {
      super(props);
  
      this.state = {
      
      };
    }
   
  
    // <img className='text-center' style={{maxWidth:650, width:"100%",maxHeight:800, height:"100%"}} src='./images/users.png' alt=''/> 
    render() {
        return (

            <div className='jumbotron'>
                <h2>Coming Soon </h2>

                <br/>
               

                
                
                <p className='text-primary'>The help item you selected is currently being updated to reflect new functionality</p>
              

                <br/>

                 
                
            </div>
        )
       


    }

}
export default withRouter(ComingSoon);
